import { Component, OnInit } from '@angular/core';
import { KalendarNeradnihDana } from './kalendar-neradnih-dana';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-kalendar-neradnih-dana-modal-update',
  templateUrl: './kalendar-neradnih-dana-modal-update.component.html'
})
export class KalendarNeradnihDanaModalUpdateComponent extends BaseModalUpdateComponent<KalendarNeradnihDana> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KalendarNeradnihDana>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
